export const GET_GALLERY_LIST = 'GET_GALLERY_LIST';
export const SET_IS_SHOW_VIRTUAL_MODAL = 'SET_IS_SHOW_VIRTUAL_MODAL';
export const SET_ACTIVE_GALLERY = 'SET_ACTIVE_GALLERY';
